import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateMiddle',
    standalone: false,
})
export class TruncateMiddlePipe implements PipeTransform {
    transform(value: string, visibleChars = 6): string {
        if (value.length <= visibleChars * 2) {
            return value;
        }
        return `${value.slice(0, visibleChars)}...${value.slice(-visibleChars)}`;
    }
}
